import CompanyForm from '@components/company/CompanyForm'
import View from '@components/View'
import { useParams } from 'react-router-dom'

const CompanyDetailsView = () => {
  const params = useParams()

  return (
    <View title={`Company ${params.companyID}`}>
      <CompanyForm context="company-details" companyID={parseInt(params.companyID)} />
    </View>
  )
}

export default CompanyDetailsView
